<template>
  <div>
    <button v-if="!isEditing" @click="showInput()" class="tw-py-2.5 tw-text-center sm:tw-text-left tw-underline tw-decoration-dashed tw-underline-offset-2 tw-w-full tw-block tw-text-sm tw-font-medium tw-text-gray-600 tw-truncate tw-decoration-gray-400" :title="notesInput ? 'Clique aqui para editar a observação' : 'Clique aqui para adicionar observação'">
      {{notesInput ? notesInput : 'Adicionar observação'}}
    </button>
    <div v-if="isEditing" class="tw-relative tw-border-none tw-border-b tw-border-gray-300 focus-within:tw-border-blue-600">
      <input
        ref='nameInput'
        type="text"
        v-model="notesInput"
        class="form-input tw-block tw-w-full tw-border-0 tw-border-b tw-border-transparent tw-bg-gray-50 focus:tw-border-blue-600 focus:tw-ring-0 sm:tw-text-sm"
        :disabled="isSaving"
        @keyup.esc="stopEditing()"
        @keyup.enter="save()"
        focus @focusout="save()"
        placeholder="Observação">
      <img v-bind:src="loadingImage" v-show="isSaving" class="tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2" >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loadingImage from 'images/spinner.svg';

export default {
  props: ["id", "url", "notes"],
  data() {
    return {
      loadingImage,
      notesInput: this.notes,
      isEditing: false,
      isSaving: false,
    };
  },
  methods: {
    showInput() {
      this.isEditing = true
      this.$nextTick(() => this.$refs.nameInput.focus())
    },
    stopEditing(){
      this.isEditing = false
    },
    save() {
      if(this.notes == this.notesInput) {
        this.isEditing = false
        return
      }
      this.isSaving = true
      axios
        .put(this.url, {
          authenticity_token: document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
          upload: {
            notes: this.notesInput
          }
        })
        .then(response => {
          this.isEditing = false
          this.isSaving = false
        })
        .catch(error => {
          Bugsnag.notify(error)
        });
    }
  }
};
</script>
